import { Box, Button, Grid, Theme, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';
import { Image, Spinner } from 'react-bootstrap';
import ButtonLoading from '../../components/ButtonLoading';
import ButtonUploadImage, { FileT } from '../../components/ButtonUploadImage';
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete';
import TextFieldValidate from '../../components/TextFieldValidate';
import colors from '../../constants/colors';
import config from '../../constants/config';
import images from '../../constants/images';
import { uploadFileServer } from '../../utils/RequestMethods';
import { UserRegisterT } from './RegisterScreen';
import Validator from 'jsonschema'

var schema = {
    "id": "/formCompanyRegister",
    "type": "object",
    "properties": {
        "companyName": { "type": "string", "minLength": 1 },
        "companyAddress": { "type": "string", "minLength": 2 },
    },
    "required": ["companyName", 'companyAddress']
};



const useStyles = makeStyles((theme: Theme) => createStyles({
    imageContainer: {
        position: "relative",
        border: "1px solid #ccc",
        height: 150,
        width: 150,
        marginLeft: 0,
        marginRight: 0,
        marginBottom: 0,
        "&:hover,&:active,&:focus": {
            borderStyle: "dashed",
            borderColor: colors.blue_2,
            cursor: "pointer",
            "& .button-upload": {
                zIndex: 5,
                backgroundColor: colors.blue_2,
                color: colors.white,
            },
            "& .hide": {
                display: "block",
            }
        },
        "& .image": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%", height: "100%",
            zIndex: 2
        },
        "& .button-upload": {
            position: "absolute",
            top: "50%",
            left: "40%",
            zIndex: 1,
            border: "1px solid #ccc",
            borderRadius: 20,
            height: 30,
            width: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: colors.blue_2,
        },
        "& .hide": {
            display: "none",
        },
        "& .box-spinner": {
            position: "absolute",
            top: "50%",
            left: "40%",
            zIndex: 40,
            border: "1px solid #ccc",
            borderRadius: 20,
            height: 30,
            width: 30,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: colors.blue_2,
        },
    },
    inputCommant: {
        height: "100%",
        "& .MuiFilledInput-root": {
            height: "100%",
        },
        "& .MuiInput-root": {
            height: "100%",
        },

    }
}))

export type ICompanyTabProps = {
    fields: UserRegisterT
    onChangeField(key: string, value: any): void
    nextTab(fields: UserRegisterT): void
}

const CompanyTab: React.FC<ICompanyTabProps> = (props) => {
    const [fileProfilePic, setFileProfilePic] = React.useState(null)
    const [tempFile, setTempFile] = React.useState<FileT | null>(null);
    const [processing, setProcessing] = React.useState(false);
    const validatorRef = React.useRef(new Validator.Validator())
    const classes = useStyles()


    const saveCompanyLogo = async (file): Promise<any> => {
        setTempFile(file)
        // setProcessing(true)
        // uploadFileServer(file).then((res) => {
        //     setProcessing(false)
        //     if (res.source_url) {
        //         // onChangeValue("image", res.source_url)
        //     }
        // }).catch((error) => {
        //     setProcessing(false)
        // })
    }

    const checkValidate = React.useCallback((params: UserRegisterT) => {
        if (!validatorRef || !validatorRef.current) {
            return false
        }
        const valid = validatorRef.current.validate(params, schema)
        if (!valid.valid) {
            return false
        }
        return true
    }, [props.fields]);

    const next = async (params: any): Promise<string> => {
        try {

            if (checkValidate(params)) {
                props.nextTab(params)
                return ""
            }
        } catch (error) {
            throw error
        }
    }


    const onChangeField = (key: string, value: any): void => {
        props.onChangeField(key, value)

    }

    const getValue = (key, fields) => {
        return fields[key] && fields[key] != null ? fields[key] : ""
    }

    return (
        <Grid container spacing={4}>
            <Grid item lg={2} xs={12}>
                <Box className='d-flex flex-column' style={{ gap: 4 }}>
                    <Typography>Company Logo</Typography>
                    <ButtonUploadImage
                        type="button"

                        //default={false}
                        accept={"image/png, image/jpeg"}
                        className={`${classes.imageContainer}`}
                        onChangeFile={saveCompanyLogo}>
                        <Box style={{ width: "100%", height: "100%" }}>
                            {(tempFile?.uri || props?.fields?.companyLogo) && <Image
                                rounded
                                src={tempFile?.uri ? tempFile?.uri : props?.fields?.companyLogo}
                                className='image'
                            />}
                        </Box>
                        <Box className={`d-flex flex-column button-upload ${tempFile?.uri || props?.fields?.companyLogo ? "hide" : ""}`}>
                            <i className='fa fa-upload' />

                        </Box>
                        {processing && <Box className='box-spinner'>
                            <Spinner animation='border' />
                        </Box>}
                        {/* <Typography variant='caption' component={"span"}>Select company logo</Typography> */}
                    </ButtonUploadImage>

                </Box>

            </Grid>
            <Grid item lg={10} xs={12} >
                <Box className='d-flex mt-5 h-100 w-100 flex-fill flex-column justify-content-center '>
                    <Grid item xs={12} >
                        <TextFieldValidate

                            name="companyName"
                            fullWidth required variant="standard"
                            label="Company Name"
                            value={`${getValue("companyName", props.fields)}`}
                            onChange={(event: any) => {
                                let value = event.target.value
                                onChangeField("companyName", value)
                            }}
                            onValidateError={(value) => {
                                return value == "" ? "Required" : ""
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>

                        <GoogleMapAutoComplete
                            // idAddresss={`addressLoction-${uniqueId}`}
                            customInput={TextFieldValidate}
                            // className={` ${ea.textField}`}
                            fullWidth
                            required
                            InputProps={{
                                // disableUnderline: true,
                                variant: "standard",
                                onError: (value) => {
                                    return value == "" ? "Required" : ""
                                }
                            }}
                            label="Address"
                            variant="standard"
                            menuPortal={{
                                menuPlacement: 'top',
                                menuPosition: "absolute",

                            }}

                            apiKey={config.keyMap}
                            onChangeText={text => { }}
                            onPress={async location => {
                                onChangeField("companyAddress", location.verbose_address)
                            }}
                            textValue={`${props?.fields?.companyAddress ? props?.fields?.companyAddress : ''}`}
                            onValidateError={(value) => {
                                return value == "" ? "Required" : ""
                            }}
                            placeholder="Company Address *"
                        />
                    </Grid>
                </Box>
            </Grid>

            <Grid item xs={12} >
                <Button fullWidth
                    disabled={!checkValidate(props.fields)}
                    color="success" variant="contained"
                    onClick={(e) => {
                        next(props.fields)
                    }}
                >
                    <Typography variant="button" color="#fff">Next</Typography>
                </Button>
            </Grid>
        </Grid>
    );
}

export default CompanyTab